import React, { useState } from 'react';
import './Steps.css';

const Skills = ({ formData, setFormData, language = 'fr' }) => {
  const [category, setCategory] = useState('');
  const [skill, setSkill] = useState('');

  const t = {
    title: language === 'fr' ? 'Compétences Techniques' : 'Technical Skills',
    categoryLabel: language === 'fr' ? 'Catégorie' : 'Category',
    categoryPlaceholder: language === 'fr' ? 'Ex: Langages, Outils, Frameworks...' : 'Ex: Languages, Tools, Frameworks...',
    skillLabel: language === 'fr' ? 'Compétence' : 'Skill',
    skillPlaceholder: language === 'fr' ? 'JavaScript, React, Python...' : 'JavaScript, React, Python...',
    addBtn: language === 'fr' ? 'Ajouter' : 'Add',
    noSkills: language === 'fr' ? 'Aucune compétence ajoutée' : 'No skills added'
  };

  const addSkill = () => {
    if (category.trim() && skill.trim()) {
      const newCategory = category.trim();
      const newSkillValue = skill.trim();
      
      setFormData(prev => ({
        ...prev,
        skills: {
          ...prev.skills,
          [newCategory]: [...(prev.skills[newCategory] || []), newSkillValue]
        }
      }));
      
      setSkill('');
    }
  };

  const removeSkill = (category, index) => {
    const newSkills = formData.skills[category].filter((_, i) => i !== index);
    setFormData(prev => ({
      ...prev,
      skills: { ...prev.skills, [category]: newSkills }
    }));
  };

  // Récupérer toutes les catégories existantes
  const categories = Object.keys(formData.skills).filter(cat => 
    formData.skills[cat] && formData.skills[cat].length > 0
  );

  return (
    <div className="step-content">
      <h2>{t.title}</h2>
      
      {/* Champs texte simples */}
      <div className="skills-input-simple">
        <div className="input-group">
          <label>{t.categoryLabel}</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder={t.categoryPlaceholder}
          />
        </div>

        <div className="input-group">
          <label>{t.skillLabel}</label>
          <div className="skill-input-row">
            <input
              type="text"
              value={skill}
              onChange={(e) => setSkill(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && addSkill()}
              placeholder={t.skillPlaceholder}
            />
            <button type="button" className="add-btn" onClick={addSkill}>
              {t.addBtn}
            </button>
          </div>
        </div>
      </div>

      {/* Affichage des compétences */}
      <div className="skills-display">
        {categories.length > 0 ? (
          categories.map(cat => (
            <div key={cat} className="skill-category">
              <h4>{cat}</h4>
              <div className="skill-tags">
                {formData.skills[cat].map((sk, index) => (
                  <div key={index} className="skill-tag">
                    {sk}
                    <button 
                      type="button" 
                      className="remove-tag" 
                      onClick={() => removeSkill(cat, index)}
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <p className="no-skills">{t.noSkills}</p>
        )}
      </div>
    </div>
  );
};

export default Skills;